module.exports = __webpack_public_path__ + "img/afterEvent.1ffbb67f.jpeg";